import { getBackgroundColor, getBorderColor, getIconColor } from "../../../customStyles/common";
export const defineAlertStyle = (severity: string) => ({
  backgroundColor: getBackgroundColor(severity),
  mb: '1rem',
  borderColor: getBorderColor(severity),
  border: `1px solid`,
  '.MuiAlert-icon': {
    color: getIconColor(severity),
  },
  width: '100%'
});